import { Icon } from "@dgs/core";
import React, { CSSProperties, Ref, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const DragIndicator = styled(Icon)`
	width: 20px;
	height: 20px;
	color: ${({ theme }) => theme.colors.palette.grey[50]};
`;

const DisabledIndicator = styled(Icon)`
	width: 20px;
	height: 20px;
	color: ${({ theme }) => theme.colors.palette.warning.main.base};
`;

export const Wrapper = styled.div<{ $active?: boolean; $disabled?: boolean }>`
	user-select: none;
	display: flex;
	align-items: center;
	${({ theme }) => theme.borderRadius.medium};
	border: 1px solid ${({ theme }) => theme.colors.palette.grey[40]};
	background-color: #fff;
	cursor: ${({ $disabled }) => ($disabled ? "unset" : "pointer")};
	overflow: hidden;
	box-shadow: ${({ $active, theme }) => ($active ? theme.shadows.l2 : "none")};
	transform: scale(${({ $active }) => ($active ? 1.1 : 1)});
	padding: ${({ theme }) => theme.spacing(2)};
	gap: ${({ theme }) => theme.spacing(2)};
`;
interface ItemProps {
	children: React.ReactNode;
	style?: CSSProperties;
	active?: boolean;
	disabled?: boolean;
	isFallback?: boolean;
}

export const ListItem = forwardRef(function ItemFunction(
	{ children, active, disabled = false, isFallback = false, ...props }: ItemProps,
	ref: Ref<HTMLDivElement>,
) {
	const { t } = useTranslation();

	return (
		<Wrapper ref={ref} $active={active} {...props} $disabled={disabled}>
			{isFallback ? (
				<DisabledIndicator $icon="alert" title={t("Item has no translation in the current language")} />
			) : (
				<DragIndicator $icon="drag_indicator" />
			)}
			{children}
		</Wrapper>
	);
});
